/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/prop-types */
/* eslint-disable no-prototype-builtins */
import {
  Box,
  Grid,
  useMediaQuery,
  Dialog,
  DialogContent,
  Typography,
  IconButton,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import * as Sentry from "@sentry/react";
import moment from "moment/moment";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { pickBy } from "lodash";
import { css } from "aphrodite";
import Button from "../../components/common/Button";
import {
  ALL_MEMBERS,
  FD_LEADER_MARK_ATTENDANCE,
  FD_LEADER_MARK_ATTENDANCE_FOR_MOBILE,
  FD_MARK_ATTENDANCE,
  FD_MARK_ATTENDANCE_FOR_MOBILE,
  FD_NEW_FRIEND_MARK_ATTENDANCE,
  FD_NEW_FRIEND_MARK_ATTENDANCE_FOR_MOBILE,
  LEADER_MARK_ATTENDANCE,
  LEADER_MARK_ATTENDANCE_FOR_MOBILE,
  MARK_ATTENDANCE,
  MARK_ATTENDANCE_FOR_MOBILE,
  NEW_FRIEND_MARK_ATTENDANCE,
  NEW_FRIEND_MARK_ATTENDANCE_FOR_MOBILE,
  FRIEND_MARK_ATTENDANCE,
  FRIEND_MARK_ATTENDANCE_FOR_MOBILE,
} from "../../contants/table/markAttendance";
import Attendance from "../../services/api/attendance";
import { getFirstDateOfPreviousMonth } from "../../utils/dateAndTime";
import MarkAttendanceComponent from "./markAttendanceTable/MarkAttendanceTable";
import Styles from "./styles";
import Loader from "../../components/common/Loader/Loader";
import Toast from "../../components/common/Toast";
import { selectAttendanceMeetingType } from "../../redux/selectors/attendance";
import { selectAllSIUsers } from "../../redux/selectors/user";
import Friends from "../../services/api/friend";
import { MEETING_TYPE_ID, debounce, getKey } from "../../utils/helper";
import AttendanceHeader from "./AttendanceHeader";
import { ROUTES } from "../../utils/constants";
import {
  MEETING_DIVISION_MAP,
  DIVISION_SORT_ORDER,
} from "../../contants/meetingDivisions";
import AttendanceHeaderForMobile from "./AttendanceHeaderForMobile";
import MarkAttendanceComponentForMobile from "./markAttendanceTable/MarkAttendanceTableForMobile";

const MEETING_TYPE = {
  FRIEND: "FRIEND",
  MEMBER: "MEMBER",
  NEW_FRIEND: "NEW FRIEND",
  LEADER: "LEADER",
};

const mapItems = (items, meetingType) =>
  items && items.length
    ? items.map((item) => ({
        ...item,
        originalMeetingType: item.meetingType,
        meetingType,
      }))
    : [];

const getAllMeetings = (items) => {
  if (
    !items ||
    !items.hasOwnProperty("members") ||
    !items.hasOwnProperty("friends") ||
    !items.hasOwnProperty("newFriends") ||
    !items.hasOwnProperty("leaders")
  ) {
    return [];
  }
  const { members, leaders, newFriends, friends } = items;
  return [
    ...(Array.isArray(members) ? Object.values(members) : []),
    ...(Array.isArray(leaders) ? Object.values(leaders) : []),
    ...(Array.isArray(newFriends) ? Object.values(newFriends) : []),
    ...(Array.isArray(friends) ? Object.values(friends) : []),
  ];
};

const getMeetingType = (obj = {}) => {
  if (
    obj.hasOwnProperty(MEETING_TYPE_ID.MEMBER_ID) ||
    obj.hasOwnProperty(MEETING_TYPE_ID.LEADER_ID)
  ) {
    return MEETING_TYPE.MEMBER;
  }
  return MEETING_TYPE.FRIEND;
};

const getLeaderId = (item) => `${item.memberId}-L`;

const isMeetingTypeLeader = (item, meetings) => {
  const { leaders } = meetings;
  const keyName = getMeetingType(item);
  if (keyName === MEETING_TYPE.MEMBER) {
    return (
      leaders &&
      leaders.length &&
      leaders.some((leader) => leader.memberId === item.memberId)
    );
  }
  return false;
};

const getAttendanceList = (attendanceList, meetings) => {
  if (!meetings || typeof meetings !== "object") {
    return [];
  }
  const allMeetings = getAllMeetings(meetings);

  return allMeetings.map((meeting) => {
    const keyName = getKey(meeting);
    const id = meeting.memberId || meeting.leaderId || meeting.friendId;
    const sanitizeId = isMeetingTypeLeader(meeting, meetings)
      ? getLeaderId(meeting)
      : id;
    return {
      [keyName]: id,
      present: attendanceList.includes(sanitizeId),
      attendeeType: getMeetingType(meeting),
    };
  });
};

const mapQueryItems = (id) => (id.includes("L") ? id : Number(id));

const initializeAttendanceList = (meetings, query) => {
  const attendanceInSearchQuery = query
    ? query.split(",").map(mapQueryItems)
    : [];
  const allMeetings = getAllMeetings(meetings);
  const attendanceInApiResponse = allMeetings
    .map((item) => {
      const id = item.memberId || item.leaderId || item.friendId;
      if (item.present) {
        return isMeetingTypeLeader(item, meetings) ? getLeaderId(item) : id;
      }
      return null;
    })
    .filter(Boolean);

  return [...new Set([...attendanceInSearchQuery, ...attendanceInApiResponse])];
};

export default function MarkAttendance({ isArchive = false }) {
  const [attendanceList, setAttendanceList] = useState([]);
  const [meetings, setMeetings] = useState({});
  const [otherAttendeesCount, setOtherAttendeesCount] = useState("");
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [congratsDialog, setCongratsDialog] = useState({
    open: false,
    message: "",
    names: [],
  });
  const selectedMeetingType = useSelector(selectAttendanceMeetingType);
  const { isRegionSi } = useSelector(selectAllSIUsers);
  const navigate = useNavigate();
  const firstDateOfPreviousMonth = getFirstDateOfPreviousMonth();
  const [searchParams, setSearchParams] = useSearchParams();
  const isFirstRenderRef = useRef(true);
  const initialAttendanceRef = useRef([]);
  const initialOtherCountRef = useRef("");
  const getNewFriendsData = () => {
    return mapItems(meetings.newFriends, MEETING_TYPE.NEW_FRIEND);
  };

  const isOtherMeeting =
    selectedMeetingType?.startsWith("OTHER_MEETING_") ||
    selectedMeetingType?.endsWith("_OTHER_MEETING");

  const getOtherMeetingDisplayName = () => {
    const meetingTypeMap = {
      OTHER_MEETING_DISTRICT_PLANNING: "District Planning Meeting",
      OTHER_MEETING_CUBS_DIVISION: "Cubs Division Meeting",
      OTHER_MEETING_YOUNG_PHOENIX: "Young Phoenix Meeting",
      OTHER_MEETING_YOUNG_LION: "Young Lion Meeting",
      OTHER_MEETING_STUDENT_DIVISION: "Student Division Meeting",
      OTHER_MEETING_CAMPUS_GROUP: "Campus Group Meeting",
      OTHER_MEETING_EDUCATION_DIVISION: "Education Division Meeting",
      OTHER_MEETING_ARTS_DIVISION: "Arts Division Meeting",
      OTHER_MEETING_NEW_FRIENDS: "New Friends Meeting",
      OTHER_MEETING_HEALTHCARE_DIVISION: "Healthcare Division Meeting",
      OTHER_MEETING_MD_PILLAR: "MD Pillar Meeting",
      OTHER_MEETING_SOURCE_OF_ORIGIN: "Source of Origin Meeting",
      OTHER_MEETING_ALL_INDIA_STUDY: "All India Study",
      OTHER_MEETING_YWD_HOPE_AND_FRIENDSHIP_GATHERING: "Hope and Friendship",
      OTHER_MEETING_YMD_VANGUARD_ACADEMY: "Vanguard Academy",
      OTHER_MEETING_BSG_HQ_GONGYO_AND_TOUR: "BSG HQ Gongyo and Tour Meeting",
      OTHER_MEETING_SBTG_VISIT_BY_FRIENDS_AND_FAMILY:
        "SBTG Visit by Friend and Family Meeting",
    };
    return meetingTypeMap[selectedMeetingType] || "New Friends";
  };
  const [isSubmitLocked, setIsSubmitLocked] = useState(false);

  const onCheckHandler = (e, item) => {
    if (e.target.checked) {
      setAttendanceList((prev) => {
        const keyName = getKey(item);
        const isLeader = item.meetingType === "LEADER";
        const id = isLeader ? getLeaderId(item) : item[keyName];
        return [...prev, id];
      });
    } else {
      setAttendanceList((prev) => {
        const keyName = getKey(item);
        const isLeader = item.meetingType === "LEADER";
        const id = isLeader ? `${item[keyName]}-L` : item[keyName];
        return prev.filter((f) => f !== id);
      });
    }
  };

  const fetchAttendance = async (
    newAttendanceList = searchParams.get("q"),
    otherCount = searchParams.get("otherAttendeesCount")
  ) => {
    try {
      setLoading(true);
      const fromDate = moment(firstDateOfPreviousMonth).format("YYYY-MM-DD");

      console.log("GGGGGGGGGGGG11", selectedMeetingType);

      let data;

      if (isArchive) {
        const params = {
          meetingType: selectedMeetingType,
          from: fromDate,
        };
        const response = await Attendance.getArchiveAttendance(params);
        data = response.data;
      } else if (isOtherMeeting) {
        const response = await Attendance.getOtherMeetingAttendance({
          meetingType: selectedMeetingType,
          divisions: MEETING_DIVISION_MAP[selectedMeetingType],
        });
        data = response.data;
      } else {
        const response = await Attendance.getAttendance({
          meetingType: selectedMeetingType,
        });
        data = response.data;
      }

      const allowedDivisions = MEETING_DIVISION_MAP[selectedMeetingType] || [];

      if (allowedDivisions.length && data?.newFriends) {
        data.newFriends = data.newFriends.filter((friend) =>
          allowedDivisions.includes(friend.divisionName)
        );

        data.newFriends.sort((a, b) => {
          const orderA = DIVISION_SORT_ORDER[a.divisionName] || 999;
          const orderB = DIVISION_SORT_ORDER[b.divisionName] || 999;
          return orderA - orderB;
        });
      }

      setMeetings(data);
      setOtherAttendeesCount(data?.otherAttendeesCount || otherCount);

      const initialList = initializeAttendanceList(data, newAttendanceList);

      const REGION_MEETING_TYPES = new Set([
        "CUBS_MEETING",
        "YP_MEETING",
        "YL_MEETING",
        "SD_MEETING",
      ]);

      const otherMeetingFriends = REGION_MEETING_TYPES.has(selectedMeetingType)
        ? []
        : data?.newFriends
            ?.filter((f) => f.otherMeetingType?.includes(selectedMeetingType))
            ?.map((f) => f.friendId) || [];

      const finalInitialList = [
        ...new Set([...initialList, ...otherMeetingFriends]),
      ];

      setAttendanceList(finalInitialList);

      // ✅ snapshot store karo (first load ka data)
      initialAttendanceRef.current = finalInitialList;
      initialOtherCountRef.current = data?.otherAttendeesCount || otherCount;
    } catch (error) {
      setShowToast({
        severity: "error",
        message: "No data available for selected meeting",
      });
      Sentry.captureException(error);
    } finally {
      setLoading(false);
    }
  };

  const onChangeOtherAttendeesCount = (e) => {
    const newOtherAttendeesCount = e.target.value;
    setOtherAttendeesCount(newOtherAttendeesCount);
  };

  const handleDelete = async (friendId) => {
    try {
      await Friends.deleteNewFriend(friendId);
      setShowToast({
        severity: "success",
        message: "Delete Successfully",
      });
      const newAttendanceList = attendanceList.filter((id) => id !== friendId);
      setTimeout(() => {
        fetchAttendance(newAttendanceList?.join(","));
      }, 500);
    } catch (err) {
      setShowToast({
        severity: "error",
        message: err.message,
      });
      Sentry.captureException(err);
    }
  };

  useEffect(() => {
    fetchAttendance();
  }, [selectedMeetingType]);

  useEffect(() => {
    setIsSubmitLocked(false);
  }, [selectedMeetingType]);

  useEffect(() => {
    if (!isFirstRenderRef.current) {
      if (attendanceList.length || otherAttendeesCount) {
        const params = {
          q: attendanceList.join(","),
          otherAttendeesCount,
        };
        setSearchParams(pickBy(params, Boolean), { replace: true });
      } else {
        navigate(`/${ROUTES.ATTENDANCE.path}`, { replace: true });
      }
    } else {
      isFirstRenderRef.current = false;
    }
  }, [attendanceList, otherAttendeesCount]);

  const handleCloseCongratsDialog = () => {
    setCongratsDialog({ open: false, message: "", names: [] });
    navigate("/meetings/mark");
  };
  const onSubmit = async () => {
    if (loading || isSubmitLocked) return;

    const currentList = attendanceList || [];
    const initialList = initialAttendanceRef.current || [];

    const currentOther = Number(otherAttendeesCount || 0);
    const initialOther = Number(initialOtherCountRef.current || 0);

    // ✅ check: user ne kuch change kiya ya nahi
    const isAttendanceChanged =
      currentList.length !== initialList.length ||
      currentList.some((id) => !initialList.includes(id));

    const isOtherChanged = currentOther !== initialOther;

    if (!isAttendanceChanged && !isOtherChanged) {
      setShowToast({
        severity: "error",
        message: "No change found for submission.",
      });
      return;
    }

    if (currentList.length === 0 && currentOther === 0) {
      setShowToast({
        severity: "error",
        message: "Please select at least one attendee before submitting",
      });
      return;
    }

    if (currentOther > 10) {
      setShowToast({
        severity: "error",
        message: "Other Members cannot be more than 10",
      });
      return;
    }

    try {
      setLoading(true);

      const finalAttendanceList = getAttendanceList(
        attendanceList,
        meetings
      ).filter((item) => item.present === true);

      const basePayload = {
        meetingAttendanceList: finalAttendanceList,
        otherAttendeesCount: currentOther,
      };

      const dataPayload = isOtherMeeting
        ? {
            ...basePayload,
            otherMeetingType: [selectedMeetingType],
          }
        : basePayload;

      let response;
      if (isOtherMeeting) {
        response = await Attendance.markOtherMeetingAttendance({
          data: dataPayload,
          meetingType: selectedMeetingType,
        });
      } else {
        response = await Attendance.markAttendance({
          data: dataPayload,
          meetingType: selectedMeetingType,
        });
      }

      setIsSubmitLocked(true);

      const friendsData = response?.data || [];
      const responseMessage = response?.message?.replace(
        "Congratulations! ",
        ""
      );

      if (Array.isArray(friendsData) && friendsData.length > 0) {
        setCongratsDialog({
          open: true,
          message:
            responseMessage || "Congratulations! Friends changed to Member",
          names: friendsData,
        });
      } else {
        setShowToast({
          severity: "success",
          message: "Attendance Marked!, Redirecting to Attendance Screen",
        });
        setTimeout(() => {
          navigate("/meetings/mark");
        }, 3000);
      }
    } catch (error) {
      setShowToast({
        severity: "error",
        message: error.message,
      });
      Sentry.captureException(error);
    } finally {
      setLoading(false);
    }
  };

  const onAddNewFriendClick = () => {
    navigate("/friends/new-friend/search");
  };

  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <div>
      {!isOtherMeeting && (
        <>
          {isMobile ? (
            <AttendanceHeaderForMobile
              isArchive={isArchive}
              attendanceList={attendanceList}
              otherAttendeesCount={otherAttendeesCount}
              onChangeOtherAttendeesCount={onChangeOtherAttendeesCount}
              meetings={meetings}
              selectedMeetingType={selectedMeetingType}
            />
          ) : (
            <AttendanceHeader
              isArchive={isArchive}
              attendanceList={attendanceList}
              otherAttendeesCount={otherAttendeesCount}
              onChangeOtherAttendeesCount={onChangeOtherAttendeesCount}
              meetings={meetings}
              selectedMeetingType={selectedMeetingType}
            />
          )}
        </>
      )}
      <Grid container spacing={2}>
        {!isOtherMeeting && (
          <Grid item md={6} sm={12} className={css(Styles.gridContainer)}>
            <Box className={css(Styles.paddingRem)}>
              {isMobile ? (
                <MarkAttendanceComponentForMobile
                  columns={
                    isRegionSi
                      ? FD_MARK_ATTENDANCE_FOR_MOBILE
                      : MARK_ATTENDANCE_FOR_MOBILE
                  }
                  rowsData={mapItems(meetings.members, MEETING_TYPE.MEMBER)}
                  title={ALL_MEMBERS}
                  onCheckHandler={onCheckHandler}
                  attendanceList={attendanceList}
                  selectedMeetingType={selectedMeetingType}
                  isArchive={isArchive}
                />
              ) : (
                <MarkAttendanceComponent
                  columns={isRegionSi ? FD_MARK_ATTENDANCE : MARK_ATTENDANCE}
                  rowsData={mapItems(meetings.members, MEETING_TYPE.MEMBER)}
                  title={ALL_MEMBERS}
                  onCheckHandler={onCheckHandler}
                  attendanceList={attendanceList}
                  selectedMeetingType={selectedMeetingType}
                  isArchive={isArchive}
                />
              )}
            </Box>
          </Grid>
        )}

        <Grid
          item
          md={isOtherMeeting ? 12 : 6}
          sm={12}
          className={css(Styles.gridContainer)}
        >
          {!isOtherMeeting && (
            <Box className={css(Styles.paddingRem)}>
              {isMobile ? (
                <MarkAttendanceComponentForMobile
                  columns={
                    isRegionSi
                      ? FD_LEADER_MARK_ATTENDANCE_FOR_MOBILE
                      : LEADER_MARK_ATTENDANCE_FOR_MOBILE
                  }
                  rowsData={mapItems(meetings.leaders, MEETING_TYPE.LEADER)}
                  title="Leaders"
                  onCheckHandler={onCheckHandler}
                  attendanceList={attendanceList}
                  selectedMeetingType={selectedMeetingType}
                  isArchive={isArchive}
                />
              ) : (
                <MarkAttendanceComponent
                  columns={
                    isRegionSi
                      ? FD_LEADER_MARK_ATTENDANCE
                      : LEADER_MARK_ATTENDANCE
                  }
                  rowsData={mapItems(meetings.leaders, MEETING_TYPE.LEADER)}
                  title="Leaders"
                  onCheckHandler={onCheckHandler}
                  attendanceList={attendanceList}
                  selectedMeetingType={selectedMeetingType}
                  isArchive={isArchive}
                />
              )}
            </Box>
          )}

          <Box className={css(Styles.paddingRem)}>
            {isMobile ? (
              <MarkAttendanceComponentForMobile
                columns={
                  isRegionSi
                    ? FD_NEW_FRIEND_MARK_ATTENDANCE_FOR_MOBILE
                    : NEW_FRIEND_MARK_ATTENDANCE_FOR_MOBILE
                }
                rowsData={getNewFriendsData()}
                title={
                  isOtherMeeting ? getOtherMeetingDisplayName() : "New Friends"
                }
                isNewFriendsTable
                onCheckHandler={onCheckHandler}
                handleDelete={handleDelete}
                attendanceList={attendanceList}
                selectedMeetingType={selectedMeetingType}
                isArchive={isArchive}
                showAddButton={
                  !isArchive &&
                  (isRegionSi ||
                    selectedMeetingType === "DISCUSSION_MEETING" ||
                    selectedMeetingType === "GOSHO_MEETING" ||
                    isOtherMeeting)
                }
                onAddNewFriendClick={onAddNewFriendClick}
              />
            ) : (
              <MarkAttendanceComponent
                columns={
                  isRegionSi
                    ? FD_NEW_FRIEND_MARK_ATTENDANCE
                    : NEW_FRIEND_MARK_ATTENDANCE
                }
                rowsData={getNewFriendsData()}
                title={
                  isOtherMeeting ? getOtherMeetingDisplayName() : "New Friends"
                }
                isNewFriendsTable
                onCheckHandler={onCheckHandler}
                handleDelete={handleDelete}
                attendanceList={attendanceList}
                selectedMeetingType={selectedMeetingType}
                isArchive={isArchive}
                showAddButton={
                  !isArchive &&
                  (isRegionSi ||
                    selectedMeetingType === "DISCUSSION_MEETING" ||
                    selectedMeetingType === "GOSHO_MEETING" ||
                    isOtherMeeting)
                }
                onAddNewFriendClick={onAddNewFriendClick}
              />
            )}
          </Box>

          {!isOtherMeeting && (
            <Box className={css(Styles.paddingRem)}>
              {isMobile ? (
                <MarkAttendanceComponentForMobile
                  columns={
                    isRegionSi
                      ? FD_NEW_FRIEND_MARK_ATTENDANCE_FOR_MOBILE
                      : FRIEND_MARK_ATTENDANCE_FOR_MOBILE
                  }
                  rowsData={mapItems(meetings.friends, MEETING_TYPE.FRIEND)}
                  title="Friends"
                  onCheckHandler={onCheckHandler}
                  attendanceList={attendanceList}
                  selectedMeetingType={selectedMeetingType}
                  isArchive={isArchive}
                />
              ) : (
                <MarkAttendanceComponent
                  columns={
                    isRegionSi
                      ? FD_NEW_FRIEND_MARK_ATTENDANCE
                      : FRIEND_MARK_ATTENDANCE
                  }
                  rowsData={mapItems(meetings.friends, MEETING_TYPE.FRIEND)}
                  title="Friends"
                  onCheckHandler={onCheckHandler}
                  attendanceList={attendanceList}
                  selectedMeetingType={selectedMeetingType}
                  isArchive={isArchive}
                />
              )}
            </Box>
          )}

          {!isArchive && (
            <Box className={css(Styles.buttonstyle)}>
              <Button
                isLoading={loading}
                label={isSubmitLocked ? "Submitted" : "Submit"}
                disabled={loading || isSubmitLocked}
                onClick={debounce(onSubmit)}
              />
            </Box>
          )}
        </Grid>
      </Grid>

      {/* Congratulations Dialog */}
      {/* Congratulations Dialog */}
      <Dialog
        open={congratsDialog.open}
        onClose={handleCloseCongratsDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            padding: { xs: 2, sm: 3 },
            textAlign: "center",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
          },
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleCloseCongratsDialog}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ paddingTop: 4, paddingBottom: 4 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: { xs: 80, sm: 100 },
                height: { xs: 80, sm: 100 },
                borderRadius: "50%",
                backgroundColor: "#4caf50",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                animation: "scaleIn 0.5s ease-out",
                "@keyframes scaleIn": {
                  "0%": {
                    transform: "scale(0)",
                    opacity: 0,
                  },
                  "50%": {
                    transform: "scale(1.1)",
                  },
                  "100%": {
                    transform: "scale(1)",
                    opacity: 1,
                  },
                },
              }}
            >
              <CheckCircleOutlineIcon
                sx={{
                  fontSize: { xs: 48, sm: 60 },
                  color: "white",
                }}
              />
            </Box>

            <Typography
              variant="h5"
              component="h2"
              sx={{
                fontWeight: 600,
                color: "#2e7d32",
                marginTop: 2,
                fontSize: { xs: "1.5rem", sm: "1.75rem" },
              }}
            >
              Congratulations!
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "text.secondary",
                fontSize: { xs: "0.95rem", sm: "1.1rem" },
                lineHeight: 1.6,
                maxWidth: "90%",
                marginBottom: 1,
              }}
            >
              {congratsDialog.message}
            </Typography>

            {/* Names List with Green Tick */}
            {congratsDialog.names && congratsDialog.names.length > 0 && (
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "400px",
                  marginTop: 2,
                  marginBottom: 2,
                }}
              >
                {congratsDialog.names.map((name, index) => (
                  <Box
                    key={index.length}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "12px 16px",
                      marginBottom: "8px",
                      backgroundColor: "#f1f8f4",
                      borderRadius: "8px",
                      border: "1px solid #c8e6c9",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: "0.95rem", sm: "1rem" },
                        color: "#1b5e20",
                        fontWeight: 500,
                      }}
                    >
                      {name}
                    </Typography>
                    <CheckCircleOutlineIcon
                      sx={{
                        fontSize: 24,
                        color: "#4caf50",
                      }}
                    />
                  </Box>
                ))}
              </Box>
            )}

            <Button
              label="Done"
              onClick={handleCloseCongratsDialog}
              style={{
                marginTop: "16px",
                minWidth: "120px",
                padding: "10px 24px",
                fontSize: "1rem",
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>

      {!!showToast && (
        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => {
            setShowToast(null);
          }}
        />
      )}
      {loading && <Loader />}
    </div>
  );
}
